/**
 * Seção "Excluir conta" da aba Perfil (chamado 7116). Só o titular a vê
 * (`can_delete`, regra do backend); o membro convidado não tem a opção.
 */
import { useState } from 'react';
import { Trash2 } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAccountDeletion } from '@/hooks/use-account-deletion';
import { DELETE_ACCOUNT_SECTION_TEXT } from '@/lib/account-deletion';
import { CANCEL_BUTTON_CLASS } from '@/lib/subscription-cancellation';

import { DeleteAccountDialog } from './DeleteAccountDialog';

interface DeleteAccountCardProps {
  /** Só busca o resumo com a aba Perfil aberta. */
  enabled: boolean;
}

export default function DeleteAccountCard({ enabled }: Readonly<DeleteAccountCardProps>) {
  const { summary, deleteAccount, isDeleting } = useAccountDeletion(enabled);
  const [aberto, setAberto] = useState(false);

  if (!summary?.can_delete) return null;

  return (
    <Card className="border-red-200 dark:border-red-900">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-red-600 dark:text-red-400">
          <Trash2 className="h-5 w-5" />
          Excluir conta
        </CardTitle>
        <CardDescription>{DELETE_ACCOUNT_SECTION_TEXT}</CardDescription>
      </CardHeader>
      <CardContent>
        <Button variant="outline" className={CANCEL_BUTTON_CLASS} onClick={() => setAberto(true)}>
          Excluir minha conta
        </Button>
      </CardContent>
      <DeleteAccountDialog
        open={aberto}
        summary={summary}
        submitting={isDeleting}
        onOpenChange={setAberto}
        onConfirm={(payload) => deleteAccount(payload)}
      />
    </Card>
  );
}
